import React, { useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { fetchAttendance, fetchOvertimeAttendance } from '../../../services/AttendanceService'

const AttendanceLayout = () => {
    const [dtr, setDTR] = useState([]) // State to store employee data
    const [loading, setLoading] = useState(false) // Loading state
    const [dateStart, setDateStart] = useState('')
    const [dateEnd, setDateEnd] = useState('')
    const [recordType, setRecordType] = useState('regular') // State for record type

    // Example data structure for DataGrid
    const columns = [
        { field: 'date', headerName: 'Date', width: 200 },
        { field: 'timeIn', headerName: 'Time In', width: 150 },
        { field: 'timeOut', headerName: 'Time Out', width: 150 },
        {
            field: 'remarks',
            headerName: 'Working At',
            width: 150,
            renderCell: (params) => {
                const remark = params.value
                const badgeClass = remark === 'Home' ? 'badge-danger' : 'badge-info'
                return <span className={badgeClass}>{remark}</span>
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => {
                const status = params.value

                // Determine badge style based on status
                let badgeClass = ''

                switch (status) {
                    case 'Approved':
                        badgeClass = 'badge-success'
                        break

                    case 'Disapproved':
                        badgeClass = 'badge-danger'
                        break

                    default:
                        badgeClass = 'badge-warning'
                        break
                }

                return <span className={badgeClass}>{status}</span>
            }
        },
        { field: 'reason', headerName: 'Reason', width: 250 }
    ]

    const fetchDtrData = async () => {
        // Validate the date range
        if (new Date(dateStart) > new Date(dateEnd)) {
            alert('The start date cannot be after the end date.')
            return
        }

        setLoading(true)

        try {
            const attendance = {
                dateStart: dateStart,
                dateEnd: dateEnd
            }

            let response = null
            console.log('recordType', recordType)
            if (recordType === 'regular') {
                response = await fetchAttendance(attendance)
                console.log('fetchAttendance', response)
            } else if (recordType === 'overtime') {
                response = await fetchOvertimeAttendance(attendance)
                console.log('fetchOvertimeAttendance', response)
            }
            console.log('fetchDtrData', response)
            const dailyRecords = response.dailyTimeRecord || []
            const formattedData = dailyRecords.map((record, index) => ({
                id: index + 1, // Generate unique ID for each record
                date: record.date,
                timeIn: record.timeIn ? new Date(record.timeIn).toLocaleTimeString() : '-',
                timeOut: record.timeOut ? new Date(record.timeOut).toLocaleTimeString() : '-',
                remarks: record.remarks || '-',
                totalHours: record.totalHours || '-',
                status: record.status || '-',
                reason: record.reason || '-'
            }))

            setDTR(formattedData)
            setLoading(false)
        } catch (error) {
            console.error('Error fetching DTR data:', error)
            setLoading(false)
        }
    }

    return (
        <div className="page-container">
            <div className="page-toolbar">
                <h1 className="page-title">Daily Time Records</h1>
            </div>

            {/* Date Range Selectors - Responsive */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                <div>
                    <label className="form-label">Record Type</label>
                    <select
                        id="recordType"
                        value={recordType}
                        onChange={(e) => setRecordType(e.target.value)}
                        className="input-field"
                    >
                        <option value="regular">Regular</option>
                        <option value="overtime">Overtime</option>
                    </select>
                </div>
                <div>
                    <label className="form-label">Date Start</label>
                    <input
                        type="date"
                        id="dateStart"
                        placeholder="mm/dd/yyyy"
                        value={dateStart}
                        onChange={(e) => setDateStart(e.target.value)}
                        className="input-field"
                    />
                </div>

                <div>
                    <label className="form-label">Date End</label>
                    <input
                        type="date"
                        id="dateEnd"
                        placeholder="mm/dd/yyyy"
                        value={dateEnd}
                        onChange={(e) => setDateEnd(e.target.value)}
                        className="input-field"
                    />
                </div>

                <div className="flex items-end">
                    <button type="submit" className="btn-primary w-full" onClick={fetchDtrData}>
                        Fetch
                    </button>
                </div>
            </div>

            {/* Data Table */}
            <div className="w-full" style={{ height: 500 }}>
                <DataGrid
                    className="bg-white"
                    rows={dtr}
                    columns={columns.map((column) => ({
                        ...column,
                        headerClassName: 'header-bold'
                    }))}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    loading={loading}
                    disableSelectionOnClick
                    sx={{
                        '& .MuiDataGrid-columnHeaders': {
                            fontWeight: 'bold'
                        },
                        '& .MuiDataGrid-cell': {
                            cursor: 'default',
                            pointerEvents: 'none'
                        }
                    }}
                />
            </div>
        </div>
    )
}

export default AttendanceLayout
